import { useContext } from "react";
import { I18nContext, type I18n } from "./core";

export function useI18n(): I18n {
  return useContext(I18nContext);
}

/** The common case: `const t = useT()` then `t("app.logOut")`. */
export function useT(): I18n["t"] {
  return useContext(I18nContext).t;
}
